import { createContext, useContext } from 'react';
import { FeatureFlags } from '../providers/FeatureFlagsProvider/types';
import { featureFlagDefaults } from '../providers/FeatureFlagsProvider/flags';

export const FeatureFlagsContext = createContext<FeatureFlags>(featureFlagDefaults);
export const useFeatureFlags = (): FeatureFlags => useContext(FeatureFlagsContext);
